export default __webpack_public_path__ + "98c072155c25195df9b0015da6dbe52f.woff";